import './style.scss'
import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { IoIosArrowBack } from "react-icons/io"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AppLink, AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import utility from "src/utils/utility"
import { ProductInfoTab } from "src/component"
import ProductImage from 'src/assets/img/product-image.png'
//import ProductImage from 'src/assets/img/product-image.svg'
import QoreidIcon from 'src/assets/img/qoreid-icon.svg'
import { EditProduct } from 'src/popup'
import { Product } from 'src/model'
import EditIcon from 'src/assets/svg/product-edit-icon'

const ProductDetails = () => {
    const navigate = useNavigate()
    const { productId } = useParams()
    const {API} = useContext(ApiContext)
    const {info: {selectedProduct}} = useContext(AppInfoContext)
    const [productImage, setProductImage] = useState(ProductImage)
    const [product, setProduct] = useState<Product|null>(selectedProduct)
    const [view, setView] = useState('')

    useEffect(() => {
        if (selectedProduct?.id) {
            setProduct(selectedProduct)
            setProductImage(selectedProduct?.screenshotUrls?.[0])
        }
    }, [selectedProduct])

    useEffect(() => {
        //API.getProductById(productId)
    }, [])


    return (
        <>
            <PageWrapper>
                <FlexRow justifyContent="space-between" gap="2.5" wrap='wrap'>
                    <FlexRow 
                        width="auto" sizeUnit="" gap="1"
                        onClick={() => navigate(-1)}
                    >
                        <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                            <IoIosArrowBack />
                        </AppSpan>
                        {/* <CustomContainer width='4.8' height='4.8' overflow="hidden">
                            <img 
                                src={product?.logoUrl} 
                                className='img-covered' 
                                style={{objectFit: 'contain'}}  
                            />
                        </CustomContainer> */}
                        <Circle 
                            size="7" bgColor='#ffffff' 
                            borderColor='#EAECF0'
                            className='fixed-flex-shape'
                            style={{overflow: 'hidden'}}
                        >
                            <Circle 
                                size='6'
                                style={{overflow: 'hidden'}}
                            >
                                <img 
                                    src={product?.logoUrl} 
                                    className='img-covered' 
                                    style={{objectFit: 'contain'}} 
                                />
                            </Circle>
                        </Circle>
                        <PageTitle 
                            color='#101828' textSize='3' fontWeight="500"
                        >
                            Product Details
                        </PageTitle>
                    </FlexRow>
                    <FlexRow width='auto' sizeUnit='' gap='1.5' wrap='wrap'>
                        <Button
                            width='20'
                            titleSize='1.4' color='#0A756F'
                            height='4' radius='0.8'
                            bgColor='#E7F6F5'
                            hoverBgColor='#E7F6F5' borderColor='#E7F6F5'
                            onClick={() => setView('edit-product')}
                        >
                            <EditIcon style={{marginRight: '1rem'}} />
                            Edit Product Details
                        </Button>
                        <Button
                            width='14.5' 
                            height='4' radius='0.8' 
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' 
                            borderColor='#0D968F'
                            onClick={() => navigate(`/partner/product/${product?.id}/api-calls`)}
                        >
                            View API Calls
                        </Button>
                    </FlexRow>
                </FlexRow>
                
                <CustomContainer topMargin='2.5'>
                    <CustomContainer 
                        height="27" 
                        maxWidth='96.8'
                        radius='1.1' topMargin='1.5'
                        className='product-image-container'
                    >
                        <img src={ProductImage} className='img-covered' />
                    </CustomContainer>
                    {/* <CustomContainer
                        className='scrollable-container'
                    >
                        <FlexRow 
                            justifyContent='center' 
                            gap='4' topMargin='4'
                            style={{minWidth: 'fit-content'}}
                        >
                            { product?.screenshotUrls?.length! > 1 &&
                                product?.screenshotUrls?.map((img, index) => {
                                    return (
                                        <CustomContainer 
                                            width="21" height="10.1" 
                                            radius='0.8' borderColor='#E9EAEC'
                                            key={index}
                                            onClick={() => setProductImage(img)}
                                        >
                                            <img src={img} className='img-covered' />
                                        </CustomContainer>
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer> */}
                </CustomContainer>
                <CustomContainer topMargin='2.5'>
                    <ProductInfoTab
                        product={product}
                    />
                </CustomContainer>
            </PageWrapper>
            { view === 'edit-product' &&
                <EditProduct
                    data={product} 
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('product/:productId', 'Product Details', <ProductDetails/>)
